var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"announce-campaign-detail-container root mt-3"},[_c('div',{staticClass:"banner mb-3"},[_c('img',{attrs:{"src":_vm.data.imageUrl,"height":"180px","width":"100%"}})]),_c('div',{staticClass:"mt-2"},[_c('b',[_vm._v(_vm._s(_vm.data.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.description)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }